export default __webpack_public_path__ + "static/media/1180.89e0c25e.png";